import { N08_03 } from "./N08_03";

export const N08_02 = {
  selectedValueColumn: "RegionDistrictCode",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Territories",
        binding: {
          data: {
            columns: [
              {
                name: "TER Name",
                columnName: "TERName",
                width: "300px",
                align: "left",
                sortable: true,
              },
              {
                name: "Area",
                columnName: "Area",
                width: "550px",
                align: "left",
                sortable: true,
              },
              {
                name: "Coverage",
                columnName: "Coverage",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target",
                columnName: "Target",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Coverage %",
                columnName: "CoveragePercent",
                width: "150px",
                align: "center",
                sortable: true,
                percent: true,
              },
              {
                name: "TER Team",
                columnName: "TERTeam",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Working Days",
                columnName: "WorkingDays",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Average Call",
                columnName: "AverageCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target Average Call",
                columnName: "TargetAverageCall",
                width: "200px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Team Call",
                columnName: "ActualTeamCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Target Team Call",
                columnName: "TargetTeamCall",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Call Rate",
                columnName: "CallRate",
                width: "170px",
                align: "center",
                sortable: true,
                percent: true,
              },
            ],
            title: "Area",
            endpoint: "N08.2",
            parameters: [
              { key: "FromMonth", value: "CP1" },
              { key: "FromYear", value: "2026" },
              { key: "ToMonth", value: "CP1" },
              { key: "ToYear", value: "2026" },
              { key: "RegionDistrictCode", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N08_03,
            },
          },
        },
      },
    },
  ],
};
